import discoverBg from "../img/destination.jpg";
import React from "react";
import useTranslate from "../../../hooks/useTranslate";
import {DISCOVER_PAGE} from "../../../constants/ROUTER_PATH_TITLE";
import {useNavigate} from "react-router-dom";
import CitySearchInput, { CityOption } from "./CitySearchInput";

interface DiscoverPageMainProps {
    title: string;
    description?: string;
    cityId?: number;
}

const DiscoverPageMain: React.FC<DiscoverPageMainProps> = ({
    title = "Discover", description, cityId
                          }) => {
    const { t } = useTranslate();
    const navigate = useNavigate();

    const handleCitySelect = (city: CityOption) => {
        navigate(`${DISCOVER_PAGE.PATH}/${city.id}`);
    };

    return (
        <div className="relative w-full md:h-screen">
            {/* Background Image */}
            <img
                src={discoverBg}
                alt="Tropical beach view"
                className="absolute inset-0 w-full h-full object-cover landingBg"
            />

            {/* Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-20" />

            {/* Content Container */}
            <div className="relative z-10 flex flex-col justify-center items-center h-full text-center p-20 pt-[10rem] md:pt-[34rem]">
                {/* Content with Gradient Background */}
                <div className="relative">
                    {/* Gradient Background */}
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-900/20 to-blue-900/90 rounded-3xl -z-10"></div>

                    {/* Content */}
                    <div className="relative px-8">
                        {/* Main Title */}
                        <h1 className="text-white font-48-h font-semibold mb-4 syne-fm">
                            {t('valai.thingsTodoIn')} {title}
                        </h1>

                        {/* Search Form */}
                        <div className="pd-start-trip-bg w-full max-w-3xl mx-auto">
                            <CitySearchInput
                                selectedCityId={cityId}
                                onCitySelect={handleCitySelect}
                                showBorder={true}
                                placeholder={t('destination.ai.modal.searchButton')}
                            />
                        </div>

                        {/* Description */}
                        <p className="text-white font-20-h text-start mb-12 mt-8 hidden md:block">
                            {description}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DiscoverPageMain;